import React from "react";
import PropTypes from "prop-types";

const Accordion = (props) => <div className="accordion">{props.children}</div>;

Accordion.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Accordion;
